import React from 'react';
import { Helmet } from 'react-helmet-async';

function About() {
  return (
    <>
      <Helmet>
        <title>About Tacoma Off Market | Local Cash Home Buyers</title>
        <meta name="description" content="Tacoma Off Market is a team of local real estate investors who buy houses directly from homeowners. Learn about our fast, hassle-free home buying process." />
      </Helmet>
      
      <div className="container mx-auto px-4 py-12">
        <h1 className="text-4xl font-bold mb-8 text-green-700 text-center">About Tacoma Off Market</h1>
        
        <div className="prose max-w-3xl mx-auto text-center">
          <p className="text-lg mb-6">
            We are local real estate investors in Tacoma who buy houses directly from homeowners.
            Our mission is to provide a fast, hassle-free selling experience for homeowners who need to sell quickly.
          </p>
          
          <h2 className="text-4xl font-bold mb-8 text-green-700 text-center mt-12">Our Approach</h2>
          <p className="text-lg mb-6">
            Unlike traditional real estate transactions, we buy houses in any condition, with no repairs needed. 
            We handle all the paperwork and can close on your timeline, whether that's as quick as 7 days or several months out.
          </p>
          
          <h2 className="text-4xl font-bold mb-8 text-green-700 text-center mt-12">Why Choose Us?</h2>
          <ul className="list-none pl-0 mb-6">
            <li className="mb-2">No real estate agent commissions or fees</li>
            <li className="mb-2">No need to make repairs or improvements</li>
            <li className="mb-2">No cleaning required - take what you want and leave the rest</li>
            <li className="mb-2">No open houses or showings with strangers walking through your home</li>
            <li className="mb-2">No waiting months for a buyer to get financing</li>
            <li className="mb-2">No risk of buyer's financing falling through</li>
            <li className="mb-2">No closing costs</li>
          </ul>
          
          <p className="text-lg mb-6">
            Our team has years of experience in the Tacoma real estate market, and we pride ourselves on making fair cash offers with no hidden fees or commissions.
          </p>
          
          <div className="bg-green-50 p-6 rounded-lg border border-green-200 mt-8">
            <h3 className="text-xl font-bold text-green-700 mb-4">Ready to get your cash offer?</h3>
            <p className="mb-4">Contact us today to get started with a no-obligation cash offer for your property.</p>
            <a 
              href="/contact" 
              className="inline-block px-6 py-3 bg-green-600 text-white font-bold rounded-md hover:bg-green-700 transition duration-300"
            >
              Get Your Cash Offer
            </a>
          </div>
        </div>
      </div>
    </>
  );
}

export default About; 